import { Router } from '@angular/router';
import { InternalHomeService } from './internal-home/internal-home.service';
import { Component, OnInit } from '@angular/core';
import { LS_LANG, DEFAULT_LANG, BASE_HREF, LINKS_EXTERNAL, STORAGE } from 'src/app/core/utils/constants';
//import { TokenValid } from 'src/app/core/auth/tokenvalid.model';
import * as _ from 'lodash';
import { AuthenticationService } from 'src/app/core/auth/authentication.service';
//import { CommentsUsuario } from 'src/app/core/entities/commentsUsuario.model';

@Component({
  selector: 'app-internal',
  templateUrl: './internal.component.html',
  styleUrls: []
})
export class InternalComponent implements OnInit {

  readonly AYUDA: String = BASE_HREF + '/assets/images/help-btn.svg';
  readonly SALIR: String = BASE_HREF + '/assets/images/logout.svg';
  readonly REUS_AYUDA: String = LINKS_EXTERNAL.REUS_AYUDA;
  readonly REUS_AYUDA_CAS: String = LINKS_EXTERNAL.REUS_AYUDA_CAS;
  AyudaLang: String = "";

  constructor(private internalHomeService: InternalHomeService,
              private authenticationService: AuthenticationService,
              public router: Router) {}

  ngOnInit() {

    let lang = localStorage.getItem(LS_LANG) || DEFAULT_LANG;

    if(lang === 'ca'){
      this.AyudaLang = this.REUS_AYUDA;
    }else{
      this.AyudaLang = this.REUS_AYUDA_CAS;
    }

    console.log("internal.component");
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Salir a la página de inicio
  */
  public salir(){
    this.authenticationService.doLogout();
    this.router.navigate(['/internal/acces']);
  }

}
